import React, { useEffect } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as DeliveryDriversActions from "../../../store/actions/DeliveryDrivers";
import {
  DriverBasicDetailsContainer,
  FieldHolder,
} from "../../../constants/assets/DriverDetailsContainers";
import LogsListFields from "../../../constants/DeliveryDrivers/LogsListFields.json";
import BlankState from "../../Common/BlankState";
import variables from "../../../constants/assets/variables";
import moment from "moment";
import { FieldsContainer } from "../../../constants/assets/containers";

const DriverLogsDetails = ({ driverLogsDetails, getDriverLogsDetails }) => {
  const { id } = useParams();

  const getFieldValue = (field, key) => {
    if (key.includes("time")) {
      return moment(field[key]).format("YYYY-MM-DD | HH:mm:ss");
    } else return field[key];
  };

  useEffect(() => {
    if (driverLogsDetails.length === 0) {
      getDriverLogsDetails(id);
    }
  }, []);

  return (
    <DriverLogsDetailsContainer>
      <FieldsContainer>
        <FieldHolder repeat={5} display="grid">
          {LogsListFields.map((field, index) => {
            return <span key={index}>{field.name}</span>;
          })}
        </FieldHolder>
        {driverLogsDetails.length > 0 ? (
          driverLogsDetails.map((log, index) => {
            return (
              <FieldHeading repeat={5} display="grid">
                {LogsListFields.map((field, idx) => {
                  return (
                    <span key={index + idx}>
                      {getFieldValue(log, field.key)}
                    </span>
                  );
                })}
              </FieldHeading>
            );
          })
        ) : (
          <BlankState message=" " />
        )}
      </FieldsContainer>
    </DriverLogsDetailsContainer>
  );
};

const DriverLogsDetailsContainer = styled(DriverBasicDetailsContainer)``;

const FieldHeading = styled(FieldHolder)`
  span {
    color: ${variables.black};
    word-break: break-all;
  }
`;

function mapStateToProps(state) {
  const { DeliveryDrivers } = state;
  return {
    driverLogsDetails: DeliveryDrivers.driverLogs,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDriverLogsDetails: bindActionCreators(
      DeliveryDriversActions.getDriverLogsDetails,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DriverLogsDetails);
